<template>
  <div>
    <el-form ref="receiveObjForm" :model="receiveObj" label-width="80px">
      <el-row>
        <el-col :span="12">
          <el-form-item :label="$t('text.batchRemark')">
            <el-input
              size="small"
              v-model.trim="receiveObj.remark"
              :placeholder="$t('text.batchRemark')"
              style="width: 300px"
              @blur="blurRemark"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <vxe-table
        :data="items"
        class="recordsTable"
        size="mini"
        highlight-hover-row
        :scroll-y="{ enabled: false }"
      >
        <vxe-table-column
          field="images"
          :title="$t('product.images')"
          width="85"
        >
          <template v-slot="{ row }">
            <thumbnail :images="row.images"></thumbnail>
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="associateSerialNo"
          :title="$t('stock.associateSerialNo')"
          min-width="130"
        >
          <template v-slot="{ row }">
            {{ row.associateSerialNo }}
            <div class="font10">
              {{ $t("text.type") }}：{{ $t("receiveTypes." + row.type) }}
            </div>
          </template>
        </vxe-table-column>

        <vxe-table-column
          field="productNo"
          :title="$t('product.productNo')"
          min-width="100"
        >
          <template v-slot="{ row }">
            {{ row.productNo }}
            <div class="font10">{{ row.color }} {{ row.size }}</div>
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="quantity"
          :title="$t('text.quantity')"
          min-width="50"
        />
        <vxe-table-column
          field="receiveQuantity"
          :title="$t('receive.receivedQuantity')"
          min-width="100"
        />
        <vxe-table-column :title="$t('order.receiveQuantity')" min-width="80">
          <template v-slot="{ row }">
            <el-input
              v-model="row.receiveQty"
              size="small"
              :placeholder="row._maxReceiveQty"
            ></el-input>
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="specJson"
          :title="$t('product.specJson')"
          min-width="100"
        >
          <template v-slot="{ row }">
            <attribute :content="row.specJson" :number="12" />
          </template>
        </vxe-table-column>
        <vxe-table-column :title="$t('text.remark')" min-width="100">
          <template v-slot="{ row }">
            <el-input
              v-model="row.receiveRemark"
              size="small"
              :placeholder="$t('text.remark')"
            ></el-input>
          </template>
        </vxe-table-column>
        <vxe-table-column field="action" :title="$t('text.action')" width="50">
          <template v-slot="{ row, rowIndex }">
            <el-button type="text" @click="remove(row, rowIndex)" size="mini">
              {{ $t("text.remove") }}
            </el-button>
          </template>
        </vxe-table-column>
      </vxe-table>
    </el-form>

    <div class="right pd20">
      <span class="mgr10">
        {{ $t("text.total") }}：{{ countCurrnetTotal() }}
      </span>
      <el-button
        size="small"
        type="primary"
        :loading="submitDoing"
        @click="submit"
      >
        {{ $t("text.submit") }}
      </el-button>
      <el-button size="small" type="default" @click="close">
        {{ $t("text.close") }}
      </el-button>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import { page } from "@/utils/mixins.js";
import Util from "@/utils";
import Receive from "@/api/receive.js";

export default {
  props: {
    items: Array,
  },
  mixins: [page],
  components: {},
  data() {
    return {
      receiveObj: {
        remark: null,
      },
      submitDoing: false,
    };
  },
  created() {
    const self = this;
    for (const item of self.items) {
      // const maxReceiveQty = item.quantity - (item.receiveQuantity || 0);
      const maxReceiveQty = item.canReceiveQuantity;
      Vue.set(item, "receiveQty", maxReceiveQty);
      Vue.set(item, "_maxReceiveQty", maxReceiveQty);
      Vue.set(item, "receiveRemark", null);
    }
    self.countCurrnetTotal();
  },

  methods: {
    blurRemark() {
      if (this.receiveObj.remark != null && this.receiveObj.remark != "") {
        for (const item of this.items) {
          item.receiveRemark = this.receiveObj.remark;
        }
      }
    },
    countCurrnetTotal(records) {
      let total = 0;
      if (this.items.length === 0) {
        return 0;
      }
      this.items.map((d) => {
        total += Number(d.receiveQty);
      });
      return total;
    },
    remove(row, rowIndex) {
      this.items.splice(rowIndex, 1);
      this.countCurrnetTotal();
    },
    submit() {
      const self = this;
      if (self.items.length === 0) {
        self.$message.error(self.$t("prompt.atLeastOneData"));
        return;
      }

      for (const item of self.items) {
        if (
          !Util.regexQuantity(item.receiveQty) ||
          item.receiveQty === "0" ||
          item.receiveQty > item._maxReceiveQty
        ) {
          self.$message({
            message: this.$t("rules.regex", [this.$t("order.receiveQuantity")]),
            type: "warning",
          });
          return;
        }
      }
      const data = self.items.map((i) => {
        return {
          id: i.id,
          quantity: i.receiveQty,
          remark: i.receiveRemark,
        };
      });
      self.submitDoing = true;
      Receive.batchReceive(data).then(function (res) {
        self.submitDoing = false;
        if (res.status == 200) {
          self.sysResults(res.data, self.$t("prompt.receiveSuccess"));
          self.$emit("updateData");
          self.$eventHub.$emit("receiveBatchReceive");
        } else {
          self.sysError();
        }
      });
    },
    close() {
      this.$emit("close");
    },
  },
};
</script>
